import { render, staticRenderFns } from "./ui-table.vue?vue&type=template&id=3b78e651&scoped=true&"
import script from "./ui-table.vue?vue&type=script&lang=js&"
export * from "./ui-table.vue?vue&type=script&lang=js&"
import style0 from "./ui-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78e651",
  null
  
)

export default component.exports